<template>
  <div v-if="show" class="s-carousel-page-nav">
    <button
      type="button"
      :class="['s-carousel-page-nav__control', prevClass]"
      aria-label="Previous"
      v-if="showNavigation"
    >
      <Icon name="arrow-left" />
    </button>
    <div :class="['s-carousel-page-nav__pagination', paginationClass]" />
    <button
      type="button"
      :class="['s-carousel-page-nav__control', nextClass]"
      aria-label="Next"
      v-if="showNavigation"
    >
      <Icon name="arrow-right" />
    </button>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/elements/Icon.vue';
import type { CarouselPageNavProps } from '@/types/sections/carousel-page-nav';

withDefaults(defineProps<CarouselPageNavProps>(), {
  show: true,
  prevClass: 'prev',
  paginationClass: 'pagination',
  nextClass: 'next',
  showNavigation: true,
});
</script>

<style lang="scss">
.s-carousel-page-nav {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.s-carousel-page-nav__control {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid rgba(0, 10, 70, 0.16);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(13px);
  color: #000a46;
  box-shadow: 0 4px 12px rgba(18, 30, 110, 0.06);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    opacity 0.2s ease,
    background-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
}

.s-carousel-page-nav__control .e-icon {
  width: 16px;
  height: 16px;
}

.s-carousel-page-nav__control:disabled,
.s-carousel-page-nav__control.swiper-button-disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.s-carousel-page-nav__control:not(:disabled):not(.swiper-button-disabled):hover {
  border-color: rgba(8, 49, 194, 0.42);
  background: rgba(255, 255, 255, 0.65);
}

.s-carousel-page-nav__control:not(:disabled):not(.swiper-button-disabled):active {
  border-color: rgba(8, 49, 194, 0.56);
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 2px 8px rgba(18, 30, 110, 0.1);
}

.s-carousel-page-nav__pagination {
  position: static;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: auto;
}

.gcs-swiper-dot,
.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  margin: 0;
  border: 0;
  border-radius: 999px;
  background: #d0d8ef;
  opacity: 1;
  transition:
    width 0.2s ease,
    background-color 0.2s ease;
}

.gcs-swiper-dot.is-active,
.swiper-pagination-bullet-active {
  width: 24px;
  background: #6b9171;
}
</style>
